import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: string;
};

export function AdminGroupBuyingUpdate(route: RouteComponentProps) {
  const { match } = route;
  const history = useHistory();
  const { id } = match.params as Params; // 주문번호
  const [bookCode, setBookCode] = useState<any>(); // 서적코드
  const [bookCode1, setBookCode1] = useState<any>(); // 서적코드 1
  const [bookCode2, setBookCode2] = useState<any>(); // 서적코드 2
  const [bookCode3, setBookCode3] = useState<any>(); // 서적코드 3
  const [bookName, setBookName] = useState<any>(); // 도서명
  const [bookName1, setBookName1] = useState<any>(); // 도서명 1
  const [bookName2, setBookName2] = useState<any>(); // 도서명 2
  const [bookName3, setBookName3] = useState<any>(); // 도서명 3
  const [orderState, setOrderState] = useState<any>('견적요청'); // 상태
  const [orderState1, setOrderState1] = useState<any>('견적요청'); // 상태 1
  const [orderState2, setOrderState2] = useState<any>('견적요청'); // 상태 2
  const [orderState3, setOrderState3] = useState<any>('견적요청'); // 상태 3
  const [effectiveDate, setEffectiveDate] = useState<any>(); // 견적유효일 1
  const [effectiveDate1, setEffectiveDate1] = useState<any>(); // 견적유효일 1
  const [effectiveDate2, setEffectiveDate2] = useState<any>(); // 견적유효일 2
  const [effectiveDate3, setEffectiveDate3] = useState<any>(); // 견적유효일 3
  const [approvalDate1, setApprovalDate1] = useState<any>(); // 승인완료일 1
  const [approvalDate2, setApprovalDate2] = useState<any>(); // 승인완료일 1
  const [approvalDate3, setApprovalDate3] = useState<any>(); // 승인완료일 1
  const [bookPrice, setBookPrice] = useState<any>(); // 정가
  const [bookPrice1, setBookPrice1] = useState<any>(); // 정가 1
  const [bookPrice2, setBookPrice2] = useState<any>(); // 정가 2
  const [bookPrice3, setBookPrice3] = useState<any>(); // 정가 3
  const [discountRate, setDiscountRate] = useState<any>(); // 권당 할인율
  const [discountRate1, setDiscountRate1] = useState<any>(); // 권당 할인율 1
  const [discountRate2, setDiscountRate2] = useState<any>(); // 권당 할인율 2
  const [discountRate3, setDiscountRate3] = useState<any>(); // 권당 할인율 3
  const [discountPrice, setDiscountPrice] = useState<any>(); // 권당 예상금액
  const [discountPrice1, setDiscountPrice1] = useState<any>(); // 권당 예상금액 1
  const [discountPrice2, setDiscountPrice2] = useState<any>(); // 권당 예상금액 2
  const [discountPrice3, setDiscountPrice3] = useState<any>(); // 권당 예상금액 3
  const [amount, setAmount] = useState<any>(); // 권당 최종금액
  const [amount1, setAmount1] = useState<any>(); // 권당 최종금액 1
  const [amount2, setAmount2] = useState<any>(); // 권당 최종금액 2
  const [amount3, setAmount3] = useState<any>(); // 권당 최종금액 3
  const [qty, setQty] = useState<any>(); // 주문수량
  const [qty1, setQty1] = useState<any>(); // 주문수량 1
  const [qty2, setQty2] = useState<any>(); // 주문수량 2
  const [qty3, setQty3] = useState<any>(); // 주문수량 3
  const [totalAmount, setTotalAmount] = useState<any>(); // 최종금액
  const [totalAmount1, setTotalAmount1] = useState<any>(); // 최종금액 1
  const [totalAmount2, setTotalAmount2] = useState<any>(); // 최종금액 2
  const [totalAmount3, setTotalAmount3] = useState<any>(); // 최종금액 3
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getGroupBuyingId();
  }, []);

  const paramDetail = {
    effectiveDate,
    orderState,
  };

  const paramBook = {
    discountRate,
    discountPrice,
    amount,
    qty,
    totalAmount,
  };

  // 공동구매 해당건 상세정보 조회 API 호출
  const getGroupBuyingId = async () => {
    await server
      .getGroupBuyingId(id)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          if (payload.length >= 1) {
            setBookCode1(payload[0].b_code);
            // API 준비되면 나중에 값 바꾸야함!!
            setBookName1('서적아이템 1번');
            setOrderState1(payload[0].order_state);
            setEffectiveDate1(payload[0].effective_date);
            setApprovalDate1(new Date(payload[0].approval_date).toLocaleDateString());
            // API 준비되면 나중에 값 바꾸야함!!
            setBookPrice1(30000);
            setDiscountRate1(payload[0].discount_rate);
            setDiscountPrice1(payload[0].discount_price);
            setAmount1(payload[0].result_amout);
            setQty1(payload[0].quantity);
            setTotalAmount1(payload[0].total_amount);
          }
          if (payload.length >= 2) {
            setBookCode2(payload[1].b_code);
            // API 준비되면 나중에 값 바꾸야함!!
            setBookName2('서적아이템 2번');
            setOrderState2(payload[1].order_state);
            setEffectiveDate2(payload[1].effective_date);
            setApprovalDate2(new Date(payload[1].approval_date).toLocaleDateString());
            // API 준비되면 나중에 값 바꾸야함!!
            setBookPrice2(30000);
            setDiscountRate2(payload[1].discount_rate);
            setDiscountPrice2(payload[1].discount_price);
            setAmount2(payload[1].result_amout);
            setQty2(payload[1].quantity);
            setTotalAmount2(payload[1].total_amount);
          }
          if (payload.length === 3) {
            setBookCode3(payload[2].b_code);
            // API 준비되면 나중에 값 바꾸야함!!
            setBookName3('서적아이템 3번');
            setOrderState3(payload[2].order_state);
            setEffectiveDate3(payload[2].effective_date);
            setApprovalDate3(new Date(payload[2].approval_date).toLocaleDateString());
            // API 준비되면 나중에 값 바꾸야함!!
            setBookPrice3(30000);
            setDiscountRate3(payload[2].discount_rate);
            setDiscountPrice3(payload[2].discount_price);
            setAmount3(payload[2].result_amout);
            setQty3(payload[2].quantity);
            setTotalAmount3(payload[2].total_amount);
          }
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 공동구매 삭제 API 호출
  const onClickDelete = async () => {
    if (window.confirm('해당 공동구매를 삭제하시겠습니까?') === true) {
      await server
        .getGroupBuyingDetail(id)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            dispatch(toast.info({ message: '해당 공동구매가 삭제되었습니다.' }));
            route.history.goBack();
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // 공동구매 수정 API 호출
  const onClickUpdate = async () => {
    if (bookCode1 !== undefined) {
      setEffectiveDate(effectiveDate1);
      setOrderState(orderState1);
      await server
        .patchGroupBuyingDetail(id, paramDetail)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookCode1 !== undefined) {
      setBookCode(bookCode1);
      setDiscountRate(discountRate1);
      setDiscountPrice(discountPrice1);
      setAmount(amount1);
      setQty(qty1);
      setTotalAmount(totalAmount1);
      await server
        .patchGroupBuyingBook(id, bookCode, paramBook)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookCode2 !== undefined) {
      setEffectiveDate(effectiveDate2);
      setOrderState(orderState2);
      await server
        .patchGroupBuyingDetail(id, paramDetail)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookCode2 !== undefined) {
      setBookCode(bookCode2);
      setDiscountRate(discountRate2);
      setDiscountPrice(discountPrice2);
      setAmount(amount2);
      setQty(qty2);
      setTotalAmount(totalAmount2);
      await server
        .patchGroupBuyingBook(id, bookCode, paramBook)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookCode3 !== undefined) {
      setEffectiveDate(effectiveDate3);
      setOrderState(orderState3);
      await server
        .patchGroupBuyingDetail(id, paramDetail)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    if (bookCode3 !== undefined) {
      setBookCode(bookCode3);
      setDiscountRate(discountRate3);
      setDiscountPrice(discountPrice3);
      setAmount(amount3);
      setQty(qty3);
      setTotalAmount(totalAmount3);
      await server
        .patchGroupBuyingBook(id, bookCode, paramBook)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    dispatch(toast.info({ message: '해당 공동구매가 수정되었습니다.' }));
  };

  // 공동구매 리스트
  function groupBuyingList() {
    return (
      <ul className="inputs">
        <li className="order-code input">
          <span>주문번호</span>
          <input type="string" defaultValue={id} readOnly />
        </li>
        {groupBuyingRow1}
        {groupBuyingRow2}
        {groupBuyingRow3}
      </ul>
    );
  }

  // 첫번째 데이터값 불러오기
  const groupBuyingRow1 = (
    <>
      <li />
      <li className="isbn input">
        <span>ISBN</span>
        <input type="text" defaultValue="" readOnly />
      </li>
      <li className="input">
        <span>상태</span>
        <div className="selectbox">
          <select
            name=""
            id=""
            value={orderState1 || ''}
            onChange={(event) => {
              setOrderState1(event.target.value);
            }}
          >
            <option defaultValue="견적요청">견적요청</option>
            <option defaultValue="결제완료">결제완료</option>
            <option defaultValue="출고준비">출고준비</option>
            <option defaultValue="출고완료">출고완료</option>
          </select>
        </div>
      </li>
      <li className="day">
        <span>견적유효일</span>
        <input
          type="number"
          defaultValue={effectiveDate1}
          onChange={(event) => {
            setEffectiveDate1(event.target.value);
          }}
        />
      </li>
      <li className="input">
        <span>승인완료일</span>
        <input defaultValue={approvalDate1} readOnly />
      </li>
      <li className="book-title">
        <span>도서명</span>
        <input type="text" className="full" defaultValue={bookName1} readOnly />
      </li>
      <li className="price">
        <span>정가</span>
        <input type="number" defaultValue={bookPrice1} readOnly />
      </li>
      <li className="input">
        <span>권당 할인율</span>
        <input
          type="number"
          defaultValue={discountRate1}
          onChange={(event) => {
            setDiscountRate1(event.target.value);
          }}
        />
        <button type="button" onClick={() => onClickDiscountCalc1()}>
          계산
        </button>
      </li>
      <li className="price">
        <span>권당 예상금액</span>
        <input type="number" defaultValue={discountPrice1} readOnly />
      </li>
      <li className="price">
        <span>권당 최종금액</span>
        <input
          type="number"
          defaultValue={amount1}
          onChange={(event) => {
            setAmount1(event.target.value);
          }}
        />
        <button type="button" onClick={() => onClickResultAmount1()}>
          계산
        </button>
      </li>
      <li className="quantity">
        <span>주문수량</span>
        <input type="number" defaultValue={qty1} readOnly />
      </li>
      <li className="price">
        <span>최종금액</span>
        <input type="number" defaultValue={totalAmount1} readOnly />
      </li>
    </>
  );

  // 첫번째 권당 할인율 적용 계산
  const onClickDiscountCalc1 = () => {
    setDiscountPrice1(bookPrice1 - bookPrice1 * (discountRate1 / 100));
    setAmount1(discountPrice1);
  };

  // 첫번째 최종금액 계산
  const onClickResultAmount1 = () => {
    setTotalAmount1(qty1 * amount1);
  };

  // 두번째 데이터값 불러오기
  const groupBuyingRow2 = (
    <>
      <li />
      <li className="isbn input">
        <span>ISBN</span>
        <input type="text" defaultValue="" readOnly />
      </li>
      <li className="input">
        <span>상태</span>
        <div className="selectbox">
          <select
            name=""
            id=""
            value={orderState2 || ''}
            onChange={(event) => {
              setOrderState2(event.target.value);
            }}
          >
            <option defaultValue="견적요청">견적요청</option>
            <option defaultValue="결제완료">결제완료</option>
            <option defaultValue="출고준비">출고준비</option>
            <option defaultValue="출고완료">출고완료</option>
          </select>
        </div>
      </li>
      <li className="day">
        <span>견적유효일</span>
        <input
          type="number"
          defaultValue={effectiveDate2}
          onChange={(event) => {
            setEffectiveDate2(event.target.value);
          }}
        />
      </li>
      <li className="input">
        <span>승인완료일</span>
        <input defaultValue={approvalDate2} readOnly />
      </li>
      <li className="book-title">
        <span>도서명</span>
        <input type="text" className="full" defaultValue={bookName2} readOnly />
      </li>
      <li className="price">
        <span>정가</span>
        <input type="number" defaultValue={bookPrice2} readOnly />
      </li>
      <li className="input">
        <span>권당 할인율</span>
        <input
          type="number"
          defaultValue={discountRate2}
          onChange={(event) => {
            setDiscountRate2(event.target.value);
          }}
        />
        <button type="button" onClick={() => onClickDiscountCalc2()}>
          계산
        </button>
      </li>
      <li className="price">
        <span>권당 예상금액</span>
        <input type="number" defaultValue={discountPrice2} readOnly />
      </li>
      <li className="price">
        <span>권당 최종금액</span>
        <input
          type="number"
          defaultValue={amount2}
          onChange={(event) => {
            setAmount2(event.target.value);
          }}
        />
        <button type="button" onClick={() => onClickResultAmount2()}>
          계산
        </button>
      </li>
      <li className="quantity">
        <span>주문수량</span>
        <input type="number" defaultValue={qty2} readOnly />
      </li>
      <li className="price">
        <span>최종금액</span>
        <input type="number" defaultValue={totalAmount2} readOnly />
      </li>
    </>
  );

  // 두번째 권당 할인율 적용 계산
  const onClickDiscountCalc2 = () => {
    setDiscountPrice2(bookPrice2 - bookPrice2 * (discountRate2 / 100));
    setAmount2(discountPrice2);
  };

  // 두번째 최종금액 계산
  const onClickResultAmount2 = () => {
    setTotalAmount2(qty2 * amount2);
  };

  // 세번째 데이터값 불러오기
  const groupBuyingRow3 = (
    <>
      <li />
      <li className="isbn input">
        <span>ISBN</span>
        <input type="text" defaultValue="" readOnly />
      </li>
      <li className="input">
        <span>상태</span>
        <div className="selectbox">
          <select
            name=""
            id=""
            value={orderState3 || ''}
            onChange={(event) => {
              setOrderState3(event.target.value);
            }}
          >
            <option defaultValue="견적요청">견적요청</option>
            <option defaultValue="결제완료">결제완료</option>
            <option defaultValue="출고준비">출고준비</option>
            <option defaultValue="출고완료">출고완료</option>
          </select>
        </div>
      </li>
      <li className="day">
        <span>견적유효일</span>
        <input
          type="number"
          defaultValue={effectiveDate3}
          onChange={(event) => {
            setEffectiveDate3(event.target.value);
          }}
        />
      </li>
      <li className="input">
        <span>승인완료일</span>
        <input defaultValue={approvalDate3} readOnly />
      </li>
      <li className="book-title">
        <span>도서명</span>
        <input type="text" className="full" defaultValue={bookName3} readOnly />
      </li>
      <li className="price">
        <span>정가</span>
        <input type="number" defaultValue={bookPrice3} readOnly />
      </li>
      <li className="input">
        <span>권당 할인율</span>
        <input
          type="number"
          defaultValue={discountRate3}
          onChange={(event) => {
            setDiscountRate3(event.target.value);
          }}
        />
        <button type="button" onClick={() => onClickDiscountCalc3()}>
          계산
        </button>
      </li>
      <li className="price">
        <span>권당 예상금액</span>
        <input type="number" defaultValue={discountPrice3} readOnly />
      </li>
      <li className="price">
        <span>권당 최종금액</span>
        <input
          type="number"
          defaultValue={amount3}
          onChange={(event) => {
            setAmount3(event.target.value);
          }}
        />
        <button type="button" onClick={() => onClickResultAmount3()}>
          계산
        </button>
      </li>
      <li className="quantity">
        <span>주문수량</span>
        <input type="number" defaultValue={qty3} readOnly />
      </li>
      <li className="price">
        <span>최종금액</span>
        <input type="number" defaultValue={totalAmount3} readOnly />
      </li>
    </>
  );

  // 세번째 권당 할인율 적용 계산
  const onClickDiscountCalc3 = () => {
    setDiscountPrice3(bookPrice3 - bookPrice3 * (discountRate3 / 100));
    setAmount3(discountPrice3);
  };

  // 세번째 최종금액 계산
  const onClickResultAmount3 = () => {
    setTotalAmount3(qty3 * amount3);
  };

  // AdminGroupBuyingUpdate 리턴값
  return (
    <main className="group-buying-update wrapper">
      <div className="title">
        <h1>공동구매 상세수정</h1>
        <div className="buttons">
          <button className="btn-sub" type="button" onClick={onClickDelete}>
            삭제
          </button>
          <button type="button" onClick={onClickUpdate}>
            수정
          </button>
        </div>
      </div>
      <div className="content">{groupBuyingList()}</div>
    </main>
  );
}
